// src/pages/DashboardPage.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api';
import '../styles/DashboardPage.css';

const DashboardPage = ({ isAuthenticated }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isAuthenticated) return;
    setLoading(true);
    apiClient.get('/admin/dashboard/stats')
      .then((r) => { setStats(r.data); setError(''); })
      .catch((e) => setError(e.response?.data?.detail || e.message || 'Failed to load stats.'))
      .finally(() => setLoading(false));
  }, [isAuthenticated]);

  const renderStat = (value) => {
    if (loading) return '…';
    if (error) return '—';
    return value ?? 0;
  };

  return (
    <div className="dashboard-container">
      <h2>{isAuthenticated ? 'Admin Dashboard' : 'Welcome'}</h2>
      <p>
        {isAuthenticated
          ? 'Welcome to the ZappyRewards admin dashboard!'
          : 'Please log in to manage your loyalty programs.'}
      </p>

      {isAuthenticated && error && (
        <p className="error-message">Could not load stats: {error}</p>
      )}

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h2>Active Programs</h2>
          {isAuthenticated ? (
            <>
              <p>You have <strong>{renderStat(stats?.program_count)}</strong> active program{stats?.program_count === 1 ? '' : 's'}.</p>
              <Link to="/select-program" className="button-link">View Programs</Link>
            </>
          ) : (
            <p>Log in to see your active programs.</p>
          )}
        </div>

        <div className="dashboard-card">
          <h2>Quick Stats</h2>
          {isAuthenticated ? (
            <>
              <p>Total Participants: <strong>{renderStat(stats?.participant_count)}</strong></p>
              <p>Total Points Issued: <strong>{renderStat(stats?.total_points)}</strong></p>
            </>
          ) : (
            <p>Log in to view program statistics.</p>
          )}
        </div>

        <div className="dashboard-card">
          <h2>{isAuthenticated && stats?.program_count > 0 ? 'Add a Program' : 'Get Started'}</h2>
          {isAuthenticated ? (
            <>
              <p>
                {stats?.program_count > 0
                  ? 'Create another loyalty program.'
                  : 'Create your first loyalty program.'}
              </p>
              <Link to="/setup-program" className="button-link">
                Create New Program
              </Link>
            </>
          ) : (
            <p>Log in or register to create a new loyalty program.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
